<template>
  <section class="text_center">
    <h2 class="header_underline">LINE登録完了</h2>
    <p>LINE登録が完了しました。</p>
    <p><router-link :to="{ name: 'Top' }" class="decoration_link_arrow_blue">トップページへ戻る</router-link></p>
  </section>
</template>

<script>
export default {
  name: 'LineTopComplete'
}
</script>
